import { endpoints } from "@app/api/apis";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";

export const initiateDigioMandate = async (payload: {
    applicationId: string;
    redirectionUrl : string
}) => {

    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }    
        const response = await axios.post(endpoints.dspMandateInitiateRequest, {
            applicationId,
            redirectionUrl: payload?.redirectionUrl,
        });
        return response;

}

export const checkDigioMandateStatus = async (payload: {
    applicationId: string;
}) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }  
    try {
        const response = await axios.get(endpoints.digioMandateCheckRequestStatusOnCallBack + applicationId);
        return response;
    } catch (error) {
        console.error(error);
    }
}


export const getUserProfileData = async ({payload}: {payload: {accountId: string}}) => {

  

    try {
        const response = await axios.get(endpoints.userProfile + payload.accountId);
        return response;
    } catch (error) {
        console.error(error);
    }
}



export const getLenderInfoApi = async (payload: {
    applicationId: string;
}) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }  
    try {
        const response = await axios.get(endpoints.getLenderInfo + applicationId);
        return response;
    } catch (error) {
        console.error(error);
    }   
}


export const initiateTataMandate = async (payload: {
    applicationId: string;
}) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')

    if (applicationIdStored) {
        applicationId = applicationIdStored;
    }  
        const response = await axios.post(endpoints.mandateTataLink, {
            applicationId,
            originUri: window?.location?.href,
            shouldRedirect : true
        });
        return response;
  
}



export const checkDigioMandateStatusTataApi = async (payload: {
    applicationId: string;
}) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }  
        const response = await axios.get(endpoints.tatamMandateStatus + applicationId);
        return response;
   
}


// export const getLenderInfo = async ({payload}) => {
//     const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId

   
//     if (lenderInfoResponse.status === 200) {
//         return lenderInfoResponse.data
//     }
//     return {
//         lenderAccountId: "Mirae",
//         lenderName: "Mirae Assets Financial Service",
//         lenderLogoUrl: "https://localhost:8080"
//     }
// }